import { NavLink } from "react-router-dom";
import { cn } from "@/lib/cn";

export interface TabItem {
  to: string;
  label: string;
  end?: boolean;
}

interface TabsProps {
  items: TabItem[];
}

/** Underline-style tab bar that uses NavLink for active state. */
export function Tabs({ items }: TabsProps) {
  return (
    <div className="border-b border-slate-200">
      <nav className="-mb-px flex gap-6 overflow-x-auto px-4 sm:px-8">        {items.map(({ to, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                "whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition",
                isActive
                  ? "border-brand-500 text-brand-700"
                  : "border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700",
              )
            }
          >
            {label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
